import axios from "axios";

export async function PostCallWithErrorResponse(url, requestBody) {
  var resp;

  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
} 


export async function PostCallWithErrorResponseLoggin(url, requestBody) {
  var resp;

  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      // Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}
export async function PostCallWithErrorResponseReqBody(url, requestBody) {
  var resp;

  return await fetch(url, {
    method: "POST",
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}
export async function simpleGetCallWithToken(url) {
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),
    },
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function DeleteCallWithErrorResponseWithToken(url, requestBody) {
  var resp;
  // const [progress, setProgress] = useState(0);
  // const { customerData } = useContext(AppContext);

  return await fetch(url, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),
    },
    // body: JSON.stringify({...customerData,...requestBody})
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function deleteWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "DELETE",

    headers: {
      Accept: "application/json",

      "Content-Type": "application/json",

      Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),
    },

    body: requestBody,
  }).then((response) => response.json());
}

export async function multipartPostCallWithErrorResponse(url, requestBody) {
  var resp;
  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",

      // "Content-Type": "multipart/form-data",
      Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

 export async function PostWithAuthPay(url, requestBody,api_key) {
     const Token= JSON.parse(localStorage.getItem("Token"))
    // console.log("Token",Token)
 
    try {
        const response = await axios.post(url, JSON.stringify(requestBody), {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-api-key":api_key,

          },
        })
        const result = response?.data; // Assuming response data is text, otherwise use response.text() if it is a string.
        return result; // Make sure getResult is defined elsewhere in your code
      } catch (error) {
        throw error?.response?.data??error; // Re-throw the error after logging it
      }
  }

  export async function GetWithAuth(url) {

    const Token= JSON.parse(localStorage.getItem("Token"))
    // console.log("Token",Token)
//  console.log("url==============>>>=======",url)
    try {
        const response = await axios.get(url,{
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:"jwt "+Token
          },
        })
        const result = response?.data; // Assuming response data is text, otherwise use response.text() if it is a string.
        return result; // Make sure getResult is defined elsewhere in your code
      } catch (error) {
        throw error?.response?.data??error; // Re-throw the error after logging it
      }
  }

    export async function PutWithAuthMultipart(url, requestBody) {
    // const Token=JSON.parse(await AsyncStorage.getItem(AppStrings.LOGIN_DATA))?.token
     const Token= JSON.parse(localStorage.getItem("Token"))
    // console.log("Token",Token)
 
    try {
        const response = await axios.put(url, requestBody, {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
            Authorization:"jwt "+Token
          },
        })
        const result = response?.data; // Assuming response data is text, otherwise use response.text() if it is a string.
        return result; // Make sure getResult is defined elsewhere in your code
      } catch (error) {
        throw error?.response?.data??error; // Re-throw the error after logging it
      }
  }
export async function getWithAuthCallWithErrorResponse(url) {
  var resp;
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),
    },
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function getWithRequestBodyWithErrorResponse(url, requestBody) {
  var resp;
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      // Authorization: "Token " + localStorage.getItem("USER_AUTH_TOKEN"),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}


  export const timeAndDistance = async (start, end) => {
    try {
      const response = await axios.get(`https://routing.openstreetmap.de/routed-car/route/v1/driving/${start};${end}?overview=false&alternatives=true&steps=false`);
      
      return {
        duration: new Date(Date.now() + (response?.data?.["routes"]?.[0]?.duration * 1000)).toLocaleTimeString("en-US", { hour12: false }),
        distance: response?.data?.["routes"]?.[0]?.distance,
        distanceInKm: (Number(response?.data?.["routes"]?.[0]?.distance) || 1) / 1000,
        hourAvgSpeed: (Number(response?.data?.["routes"]?.[0]?.duration) || 1) / 3600
      };
    } catch (error) {
      console.error('Error calculating time and distance:', error?.message);
      return {}; // Return empty object in case of error
    }
  };
export async function postWithAuthCallWithErrorResponse(url, requestBody) {
  var resp;
  return await fetch(url, {
    method: "POST",
    // mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      // "Content-Type": "multipart/form-data",
      Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function PostWithAuth(url, requestBody) {

   const Token= JSON.parse(localStorage.getItem("Token"))
    // console.log("Token",Token)
 
    try {
        const response = await axios.post(url, JSON.stringify(requestBody), {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:"jwt " + JSON.parse(localStorage.getItem("Token")),
          },
        })
        const result = response?.data; // Assuming response data is text, otherwise use response.text() if it is a string.
        return result; // Make sure getResult is defined elsewhere in your code
      } catch (error) {
        throw error?.response?.data??error; // Re-throw the error after logging it
      }
  }

export async function putMultipartWithAuthCallWithErrorResponse(
  url,
  requestBody
) {
  var resp;
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      //'Content-Type': 'multipart/form-data',
           "Content-Type": "application/json",
      Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function postMultipartWithAuthCallWithErrorResponse(
  url,
  requestBody
) {
  var resp;
  return await fetch(url, {
    method: "POST",

    headers: {
      Accept: "application/json",
      // "Content-Type": "application/json",
      //  'Content-Type': 'multipart/form-data',
      Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}


export async function simplePatchCall2(url, requestBody) {
  try {
    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("Token")),
      },
      withCredentials: true,
      body: JSON.stringify(requestBody),
    });

    const result = await response.text();
    return getResult(result);
  } catch (error) {
    console.error("Error making PATCH request:", error);
    throw error;
  }
}

export async function simpleGetCallWithErrorResponse(url, tokenPreefix = "jwt") {
  var resp;
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: tokenPreefix + ' ' + JSON.parse(localStorage.getItem("Token")),
    },
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}


export async function simpleGetCallWithErrorResponseWIFI(url, Token) {
  let resp;

  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Token, // ✅ FIXED
    },
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function simpleGetCallWithErrorResponseWife(url) {
  var resp;
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("Token")),
    },
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}

export async function simpleGetCall(url) {
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function simplePostCallLandmark(url, requestBody) {
let storeData =JSON.parse(localStorage.getItem("store_Location"))
  return await fetch(url, {
    method: "POST",
    // mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      // Origin: window.location.origin,
      //'Access-Control-Allow-Credentials': "*"
      user_customer_id: storeData[0].delivery_user_id,

      Authorization: storeData[0].delivery_api_key,

    },
    withCredentials: true,
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
  //.then(data=>data.json());
} 





export async function simplePostCall(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    // mode: "cors",
    headers: {
      Accept: "application/json"
      // "Content-Type": "application/json",
      // Origin: window.location.origin,
      //'Access-Control-Allow-Credentials': "*"
    },
    withCredentials: true,
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
  //.then(data=>data.json());
}

export async function simplePatchCall(url, requestBody) {
  return await fetch(url, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    withCredentials: true,
    body: requestBody, // If you're sending FormData, keep as is
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}


export async function PatchMultipartWithAuthCallWithErrorResponse(
  url,
  requestBody
) {
  var resp;
  return await fetch(url, {
    method: "PATCH",

    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      //  'Content-Type': 'multipart/form-data',
      Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),
    },
    body: requestBody,
  })
    .then((response) => {
      resp = response;
      return response.json();
    })
    .then((json) => {
      return {
        response: resp,
        json: json,
        error: !resp.ok,
      };
    });
}
export async function multipartPostCall(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      //'Content-Type': 'multipart/form-data',
      // 'Authorization': 'Token ' + await AsyncStorage.getItem(AppStrings.TOKEN)
    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function getWithAuthCall(url) {
  return await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      //Authorization: 'Token ' + (await AsyncStorage.getItem(AppStrings.TOKEN)),
    },
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function postWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      // Authorization: 'Token ' + (await AsyncStorage.getItem(AppStrings.TOKEN)),
      Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),

    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function putWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      //Authorization: 'Token ' + (await AsyncStorage.getItem(AppStrings.TOKEN)),
      Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),

    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function postMultipartWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
           Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),
    },
    withCredentials: true,
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}

export async function putMultipartWithAuthCall(url, requestBody) {
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
         Authorization: "jwt " + JSON.parse(localStorage.getItem("Token")),

    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}
export async function updateProfile(url, requestBody) {
  return await fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      // Authorization: 'Token ' + (await AsyncStorage.getItem(AppStrings.token)),
    },
    body: requestBody,
  })
    .then((response) => response.text())
    .then((result) => getResult(result));
}



//-------------------------------------
export async function getResult(data) {
  return JSON.parse(data.trim());
}
//-------------------------------------
